import { render, staticRenderFns } from "./BattleParticipantSelect.vue?vue&type=template&id=4db70388&scoped=true"
import script from "./BattleParticipantSelect.vue?vue&type=script&lang=js"
export * from "./BattleParticipantSelect.vue?vue&type=script&lang=js"
import style0 from "./BattleParticipantSelect.vue?vue&type=style&index=0&id=4db70388&prod&lang=scss"
import style1 from "./BattleParticipantSelect.vue?vue&type=style&index=1&id=4db70388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db70388",
  null
  
)

export default component.exports